import { render, staticRenderFns } from "./object-data-table.vue?vue&type=template&id=a371394a"
import script from "./object-data-table.vue?vue&type=script&lang=ts"
export * from "./object-data-table.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports